/*
 * Takes an array of raw values and returns an array of integers (percentages) that:
 * - Are proportional to the original values
 * - Sum exactly to 100
 *
 * This avoids rounding issues where independently rounded percentages
 * may total to more or less than 100%.
 */
export const normalizePercentages = (rawValues: number[]): number[] => {
  const total = rawValues.reduce((sum, val) => sum + val, 0);
  const rawPercentages = rawValues.map((val) => (total > 0 ? (val / total) * 100 : 0));

  const floored = rawPercentages.map(Math.floor);
  const remainder = 100 - floored.reduce((sum, val) => sum + val, 0);

  // distribute remaining percentage points to the highest decimal remainders
  const decimalRemainders = rawPercentages.map((p, i) => ({
    index: i,
    remainder: p - floored[i]
  }));

  decimalRemainders
    .sort((a, b) => b.remainder - a.remainder)
    .slice(0, remainder)
    .forEach(({index}) => {
      floored[index] += 1;
    });

  return floored;
};
